<template>
  <div class="container-fluid">
    <div class="row ">
      <div class="col-4">&nbsp;</div>
      <div class="col-4 " >
        <img src="/images/Convey911_Logo_266x95.png" alt="Convey911 Logo" style="border:none"/>
        <div class="card mt-3">
          <div class="border-bottom title-part-padding">
            <h4 class="card-title">{{ magicToken.token_data.agency_name }}</h4>
            <h6 class="mb-0">Download Secure Artifact</h6>
          </div>
          <div class="card-body">
            <div v-if="isLoading" class="spinner-border text-center mt-3" role="status"><span class="sr-only">Loading...</span></div>
            <div v-else >
              <div class="text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</div>
              <div class="row">
                <div class="col-2"></div>
                <div class="col-8">
                  <div class="row">
                    <div class="col p-2 text-right font-weight-bold">Filename: </div>
                    <div class="col p-2 text-left text-">{{ magicToken.token_data.filename }}</div>
                  </div>
                  <div class="row">
                    <div class="col p-2 text-right font-weight-bold">Filesize: </div>
                    <div class="col p-2 text-left">{{ bytesToSize(magicToken.token_data.filesize) }}</div>
                  </div>
                  <div class="row">
                    <div class="col p-2 text-right font-weight-bold">Content Type: </div>
                    <div class="col p-2 text-left">{{ magicToken.token_data.content_type }}</div>
                  </div>                           
                  <div class="row border-top">
                    <a :href="magicToken.token_data.url" style="display: inline-block; padding: 11px 30px; margin: 20px 0px 30px; font-size: 15px; color: #fff; background: #4fc3f7; border-radius: 60px; text-decoration:none;"> Download Artifact </a>
                  </div>
                </div>
                <div class="col-2"></div>
              </div>                   
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">&nbsp;</div>
    </div>            
  </div>
</template>

<script>
import formatter from "../mixins/formatter";

export default {
  mixins: [formatter],
  data() {
    return {
      errors: {},
      errorMsg: null,
      isLoading: false,
      savePending: false,
      userUpdated: false,
      currentUser: {}
    };
  },
  props: {
    magicToken: Object
  },
  computed: {
    error: function() {
      if (this.errors && Object.keys(this.errors).length > 0)
        return "Invalid input. Please correct the errors below and try again.";

      return false;
    }
  },
  methods: {       
    login() {
      this.$auth.loginWithRedirect();
    },           
    validation() {
      return false; //this.errors[field] !== undefined;
    },        
    hasErrors(field) {
      if (this.errors[field])
        return "text-danger";

      return "";
    },
    async saveUser() {
      this.errorMsg = null;
      this.errors = {};

      if (!this.currentUser.fname || this.currentUser.fname == "")
        this.errors["fname"] = "First name is required";
      if (!this.currentUser.lname || this.currentUser.lname == "")
        this.errors["lname"] = "Last name is required";
      if (!this.currentUser.password || this.currentUser.password == "")
        this.errors["password"] = "Please enter a password";       
      if (!this.currentUser.password1 || this.currentUser.password1 == "")
        this.errors["password1"] = "Please confirm your password";
      if (this.currentUser.password && this.currentUser.password1 && this.currentUser.password !== this.currentUser.password1)
        this.errors["password"] = "Passwords do not match";

      if (Object.keys(this.errors).length > 0) 
        return false;
      
      this.savePending = true;

      let payload = {
        fname: this.currentUser.fname,
        lname: this.currentUser.lname,
        phone: this.currentUser.phone,
        operator_id: this.currentUser.operator_id,
        password: this.currentUser.password
      };            

      try {
        await this.$ConveyApi.tokensApi.fulfillMagicToken({
          token: this.magicToken.token,
          accessToken: this.magicToken.access_token,
          payload
        });
        this.userUpdated = true;
        this.savePending = false;
      }
      catch (err) {
        this.errorMsg = (err.response && err.response.data && err.response.data.data ? err.response.data.data.error : "An error was encountered saving your account. Please try again.");
        this.savePending = false;
      }
    }
  },    
  async created() {
    if (!this.magicToken || (this.magicToken && this.magicToken.service_type != "updateCurrentUser")) {
      this.error = "Token service type not supported";
      return;
    }

    this.currentUser = this.magicToken.token_data;
  }
};
</script>